module.exports = __webpack_public_path__ + "img/Logo-24.a3171693.svg";